import { useState } from 'react';
import { authContainer } from '../../di/container';
import type { ResetPasswordInput } from '../../domain/entities/auth.entity';

export function useResetPassword() {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);

  const resetPassword = async (input: ResetPasswordInput) => {
    setIsLoading(true);
    setError(null);
    setSuccess(false);
    try {
      await authContainer.repository.resetPassword(input);
      setSuccess(true);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to reset password');
    } finally {
      setIsLoading(false);
    }
  };

  return { resetPassword, isLoading, error, success };
}
